<div
  mat-dialog-content
  cdkFocusInitial
  [ngClass]="
    data?.alignTextLeft ? 'confirmation-modal left' : 'confirmation-modal'
  "
>
  @if (data.text) {
  <div class="mb-3">{{ data.text }}</div>
  } @if (data.subtext) {
  <div class="mb-3">{{ data.subtext }}</div>
  }
</div>
<div mat-dialog-actions class="d-flex justify-content-center">
  <button
    mat-raised-button
    type="submit"
    aria-label="submit"
    class="btn-confirm"
    (click)="dialogRef.close(true)"
  >
    {{ data.confirmButtonText ? data.confirmButtonText : 'OK' }}
  </button>
  @if (!data.hideCancelBtn) {
  <button
    mat-raised-button
    type="button"
    aria-label="cancel"
    class="ms-3"
    (click)="dialogRef.close(false)"
  >
    {{ data.cancelButtonText ? data.cancelButtonText : 'Cancel' }}
  </button>
  }
</div>
